import React, { useState } from 'react';
import {
  Alert,
  AlertTitle,
  Snackbar,
  SnackbarCloseReason,
} from '@mui/material';

import { INotification } from './types';

const DEFAULT_DURATION = 6000;

export const Notification = ({
  caption,
  type = 'error',
  title,
  id,
  onRemove,
  ...otherProps
}: INotification) => {
  const [open, setOpen] = useState(true);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={DEFAULT_DURATION}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      onClose={handleClose}
      key={id}
      {...otherProps}
    >
      <Alert
        severity={type}
        sx={{ width: '100%' }}
        onClose={() => (id ? onRemove?.(id) : undefined)}
        key={id}
      >
        {title ? <AlertTitle>{title}</AlertTitle> : null}
        {caption}
      </Alert>
    </Snackbar>
  );
};
